import { AbstractFilterHandler } from '../AbstractFilterHandler';
import { FilterOptions } from '@/helpers/filter/models/FilterOptions';
import { FilterData } from '@/helpers/filter/models/FilterData';

export class PMSubPhaseFilterHandler extends AbstractFilterHandler {
    public handle(data: FilterData[], filterOptions: FilterOptions): FilterData[] {
        // console.log('PhaseFilterHandler->handle');

        const arr = JSON.parse(JSON.stringify(data)) as FilterData[];
        let res: FilterData[];

        if (filterOptions.pmSubphase !== undefined && filterOptions.pmSubphase.id !== 0) {
            // console.log('PhaseFilterHandler->handle phase:', filterOptions.phase);

            res = arr.filter((el: FilterData) => {
                el.lessons = el.lessons.filter((lesson: any) => {
                    return lesson.pm_sub_phase_id === filterOptions.pmSubphase.id;
                });

                return el;
            });
        } else {
            res = arr;
        }

        return super.handle(res, filterOptions);
    }
}
